import { render, staticRenderFns } from "./DeploymentTable.vue?vue&type=template&id=2174610a"
import script from "./DeploymentTable.vue?vue&type=script&lang=js"
export * from "./DeploymentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports